module.exports = __webpack_public_path__ + "static/media/chat-icon.312f9739.svg";